/**
 * @file Welcome.jsx
 * @description Home page content of our app
 *
 * @version 1.0.0
 * @author Carmelino Galang
 * @copyright Copyright (c) 2024, NetCyberOps LLC
 */
import React, {useEffect, useContext} from "react";
import {Image} from "react-bootstrap";
import {useNavigate} from "react-router-dom";
import {KeycloakContext} from "@context/KeycloakContext";

import "./Welcome.css";

import NavLogo from "@assets/logos/horizontal-logo.svg";

const FEATURES = [
    "dashboard-overview",
    "dashboard-endpoint",
    "dashboard-vuln",
    "dashboard-siem",
    "dashboard-email",
    "dashboard-test"
];

export default function Welcome() {
    const navigate = useNavigate();
    const {userFeatures} = useContext(KeycloakContext);

    useEffect(() => {
        if (userFeatures) {
            const firstAvailableFeature = FEATURES.find(feature =>
                userFeatures.has(feature)
            );
            if (firstAvailableFeature) {
                let dashboardName = firstAvailableFeature.split('-')[1];
                if (dashboardName === "vuln") dashboardName = "vulnerabilities";

                navigate(`/dashboards/${dashboardName}`);
            }
        }
    }, [userFeatures, navigate]);

    return (
        <div className="welcome-wrapper pt-5">
            {/* <h3 className="mb-3">Welcome to</h3>
      <div id="welcome-nco-text" className="display-2 mb-1">
        NetCyberOps
      </div>
      <h4 className="welcome-text mb-5">Professional Managed Security</h4> */}
            <Image src={NavLogo} fluid width={300} id="welcome-nco-logo"/>
        </div>
    );
}
